import React from 'react';

const AuthBackground = ({ children }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-blue-900">
      {children}
    </div>
  );
};

export default AuthBackground;